import { CFormSelect } from "@coreui/react-pro";
import PropTypes from "prop-types";

const Select = ({ value = "", children, __FormItem = true, ...props }) => {
  return (
    <>
      <CFormSelect value={value} {...props}>
        {children}
      </CFormSelect>
    </>
  );
};

Select.propTypes = {
  value: PropTypes.string,
  __FormItem: PropTypes.bool,
};

Select.defaultProps = {
  __FormItem: true,
};

export default Select;
